document.addEventListener("DOMContentLoaded", async () => {
    const { initFixedAnchorLink } = await import("../components/anchorlink.js");
    initFixedAnchorLink();

    // Event Communication Slider
    const eventEls = document.querySelectorAll(".js-slider-job");
    if (eventEls) {
        const { renderJobSupport } = await import("../components/slider.js");
        eventEls.forEach(eventEl => {
            renderJobSupport(eventEl);
        });
    }
    const anchorElDirect = document.querySelectorAll(".handle-anchorD");
    if (anchorElDirect) {
        const { initAnchorLinkDirect } = await import("../components/anchorlink.js");
        initAnchorLinkDirect(false);
    }
});
